module.exports = __webpack_public_path__ + "static/media/report2.527e07f8.png";